/** 兼容旧版图标 */
export default {
  empty: 'mdi:emoticon',
  bank: 'mingcute:bank-line',
  bank_list: 'icon-park-outline:bank-card',
  accounts: 'material-symbols:person-celebrate',
  accounts_list: 'material-symbols:manage-accounts-outline',
  domains: 'simple-icons:googledomains',
  domains_list: 'lineicons:domain',
  domains_domain: 'material-symbols:cloud-domains',
  server: 'ion:server-outline',
  server_list: 'material-symbols:format-list-bulleted',
  server_terminal: 'ic:baseline-terminal',
  dashboard: 'material-symbols:home-outline',
  dashboard_report: 'material-symbols:data-thresholding-outline',
  dashboard_business: 'tabler:device-analytics',
  dashboard_mirror: 'material-symbols:bottom-app-bar-outline',
  dashboard_land: 'ic:round-flight-land',
  sys: 'material-symbols:settings-outline',
  sys_config: 'ri:file-settings-line',
  monitor: 'mdi:monitor-multiple',
  sys_permission: 'mdi:card-account-details-star-outline',
  sys_permission_menu: 'material-symbols:format-list-bulleted',
  sys_permission_role: 'mdi:account-box-multiple-outline',
  sys_user_list: 'mdi:calendar-account-outline',
  sys_other: 'mingcute:safety-certificate-line',
  site: 'gridicons:my-sites',
  site_list: 'material-symbols:format-list-bulleted'
} as any;
